/** @param {object|null|undefined} item */
export function isOrgReferenceActive(item) {
  return ![false, 0, '0'].includes(item?.is_active);
}

function orgReferenceSortKey(item, sortBy) {
  if (sortBy === 'label') {
    return String(item?.label || item?.code || item?.name || '');
  }
  if (sortBy === 'code') {
    return String(item?.code || item?.label || item?.name || '');
  }
  return String(item?.name || item?.label || item?.code || '');
}

/** Active rows first, then by optional numeric field or name/label. */
export function sortOrgReferenceRows(items, { sortBy = 'name' } = {}) {
  return [...items].sort((a, b) => {
    const activeDelta = Number(isOrgReferenceActive(b)) - Number(isOrgReferenceActive(a));
    if (activeDelta !== 0) return activeDelta;
    if (sortBy === 'level') {
      const levelDelta = Number(a?.level ?? 0) - Number(b?.level ?? 0);
      if (levelDelta !== 0) return levelDelta;
    }
    return orgReferenceSortKey(a, sortBy).localeCompare(orgReferenceSortKey(b, sortBy), undefined, {
      sensitivity: 'base',
    });
  });
}

const ENTITY_SINGULAR = {
  locations: 'location',
  'sub-departments': 'sub-department',
  teams: 'team',
  departments: 'department',
  positions: 'position',
  grades: 'grade',
  'employment types': 'employment type',
  companies: 'company',
  countries: 'country',
};

/**
 * @param {object[]} items
 * @param {string} entityLabel plural, e.g. "locations"
 * @param {boolean} showInactive
 */
export function buildOrgReferenceCountLabel(items, entityLabel, showInactive) {
  const total = items.length;
  const active = items.filter(isOrgReferenceActive).length;
  const inactive = total - active;

  if (showInactive && inactive > 0) {
    return `${total} ${entityLabel} (${active} active, ${inactive} inactive)`;
  }

  if (active === 1) {
    const singular = ENTITY_SINGULAR[entityLabel] || entityLabel;
    return `1 active ${singular}`;
  }

  return `${active} active ${entityLabel}`;
}

export function orgReferenceRowClass(item) {
  return isOrgReferenceActive(item) ? '' : 'settings-org-section__row--inactive';
}
